<template>
	<div class="page">
		<navTitle><div class="pageTitle">电子会员证</div></navTitle>
		<div class="">
			<div class="imgBox">
				<img class="img" :src="imgUrl" alt="图片加载中..">
			</div>
			<div class="submitBtn">长按图片保存到相册</div>
		</div>
	</div>
</template>

<script>
export default {
	watch: {},
	data() {
		return {
			imgUrl: ''
		};
	},
	created() {
		this.getImg()
	},
	mounted() {

	},
	methods: {
		getImg() {
			this.$get('index/card/userAuthentication', {
				uid: localStorage.getItem('user_id'),
				type: 1
			}).then(res => {
				console.log(res)
				this.imgUrl = res.data.url
			})
		}
	}
};
</script>

<style scoped lang="stylus">
.page
	height 100vh
	background #F6F6F6
.imgBox 
	margin-top 24px
	text-align center
	margin-bottom 30px
.img 
	width 690px
	height 920px
.submitBtn
	width 376px
	height 92px
	line-height 92px
	text-align center
	background-image url('~@/static/images/my/cardBg.png')
	background-size 100% 100%
	background-position center
	font-size 26px
	word-break keep-all
	color #DE113C
	margin 0 auto
</style>
